/* eslint-disable import/prefer-default-export */
import { PAGINATION_LIMIT } from '@constants/generic';

import {
  FormSubmission,
  FormSubmissionsPagination,
  GetSubmissionsParams
} from '../types';

export const filterMockSubmissions = (
  submissions: FormSubmission[],
  params: Pick<GetSubmissionsParams, 'page' | 'limit' | 'search'>
): { data: FormSubmission[]; pagination: FormSubmissionsPagination } => {
  const page = params.page ?? 0;
  const limit = params.limit ?? PAGINATION_LIMIT;
  const search = params.search?.trim()?.toLowerCase() || '';

  const filtered = search
    ? submissions.filter((row) =>
        (row.name?.toLowerCase() || '').includes(search)
      )
    : submissions;

  const totalRows = filtered.length;
  const start = page * limit;
  const data = filtered.slice(start, start + limit);

  return {
    data,
    pagination: {
      page,
      limit,
      totalRows,
      lastPage: start + limit >= totalRows
    }
  };
};
